import { on } from "../helpers/dom-manipulation/delegate";

(() => {
    const menuShrinker = {
        /** @type {Element} */
        headerFixed: document.body,
        /** @type {number} */
        lastScrollTop: 0,
        /** @type {number} */
        delta: 100,
        /** @type {(() => void) | null} */
        unbindFocus: null,

        /**
         * Initialise the shrinking navigation bar — cache DOM refs and bind scroll listener.
         *
         * @returns {void}
         */
        init() {
            this.headerFixed =
                document.querySelector(".lux-header") ?? document.body;
            this.lastScrollTop = 0;
            this.delta = 100;
            this.shrinkListenerBinder("on");
        },

        /**
         * Collapse the header and optionally slide up the shrinking element on mobile.
         *
         * @returns {void}
         */
        shrink() {
            const _this = window.menuShrinker;

            if (!_this.headerFixed.classList.contains("collapsed")) {
                _this.headerFixed.classList.add("collapsed");
            }
        },

        /**
         * Expand the header and optionally slide down the shrinking element on mobile.
         *
         * @returns {void}
         */
        unShrink() {
            const _this = window.menuShrinker;

            if (_this.headerFixed.classList.contains("collapsed")) {
                _this.headerFixed.classList.remove("collapsed");
            }
        },

        /**
         * Scroll handler — shrink or unshrink based on scroll direction and delta.
         *
         * @returns {void}
         */
        shrinkListener() {
            const _this = window.menuShrinker;
            const scrollTop = window.pageYOffset ?? 0;

            if (Math.abs(_this.lastScrollTop - scrollTop) >= _this.delta) {
                if (scrollTop > _this.lastScrollTop) {
                    _this.shrink();
                } else {
                    _this.unShrink();
                }
                _this.lastScrollTop = scrollTop;
            }
        },

        /**
         * Bind or unbind scroll/resize/focus listeners for the shrink behaviour.
         *
         * @param {"on" | "off"} act - Whether to bind ("on") or unbind ("off") the listeners.
         * @returns {void}
         */
        shrinkListenerBinder(act) {
            if (act === "on") {
                document.addEventListener("scroll", this.shrinkListener);
                document.addEventListener("resize", this.unShrink);
                this.unbindFocus = on(
                    this.headerFixed,
                    "focus",
                    "a, input, button",
                    this.unShrink,
                    { capture: true },
                );
            } else {
                document.removeEventListener("scroll", this.shrinkListener);
                document.removeEventListener("resize", this.unShrink);
                this.unbindFocus?.();
                this.unbindFocus = null;
            }
        },
    };

    menuShrinker.init();

    window.menuShrinker = menuShrinker;
})();
